import React from 'react';
import { connect } from 'react-redux';
import '../styles/App.scss';
import actions from '../actions';
import Footer from '../components/Footer';
import Modal from '../components/Modal';

const App = props => (
  <div className="App">
    { props.children }
    <Footer />
    <Modal {...props} />
  </div>
);

App.propTypes = {
  children: React.PropTypes.object.isRequired
};

const mapStateToProps = ({ modalContent }) => ({
  modalContent
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => {
    dispatch(
      actions.closeModal()
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/layouts/App.js